import React from 'react'
import { Helmet } from 'react-helmet'

import { isUnderTest } from '../Helpers/isUnderTest'
import { useHasConsent } from '../Hooks/useHasConsent/useHasConsent'

export const LinkedInPixel: React.FC<{}> = () => {
  const hasConsent = useHasConsent(['thirdparty'])
  if (isUnderTest()) return
  const linkedInId = process.env.LINKEDIN_PARTNER_ID

  return hasConsent && linkedInId ? (
    <Helmet>
      <script type={'text/javascript'}>
        {`
        _linkedin_partner_id = "${linkedInId}"; window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || []; window._linkedin_data_partner_ids.push(_linkedin_partner_id); 
        (function(l) { if (!l){window.lintrk = function(a,b){window.lintrk.q.push([a,b])}; window.lintrk.q=[]} var s = document.getElementsByTagName("script")[0]; var b = document.createElement("script"); b.type = "text/javascript";b.async = true; b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js"; s.parentNode.insertBefore(b, s);})(window.lintrk);
        `}
      </script>
      <noscript>
        {`<img
          alt={''}
          height={'1'}
          src={'https://px.ads.linkedin.com/collect/?pid=${linkedInId}&fmt=gif'}
          style={{ display: 'none' }}
          width={'1'}/>`}
      </noscript>
    </Helmet>
  ) : null
}
